export default __webpack_public_path__ + "static/yoga-3-e0fbae36eaa1732fdc1c2f89851d8a7e.png";